import { Input } from 'antd';
import { InputProps } from 'antd/lib/input';
import React, { ReactElement} from 'react';
import { multiEmailValidation } from '../../../../utils/utility';
import { useGetFormConfig } from '../../../hooks/useFormConfig';
import FormItem from '../FormItem/FormItem';

export const FormMultiEmailInput = (props: any): (ReactElement | null) => {
  const formConfig = useGetFormConfig(props);
  const {
    label, placeholder, disabled, onChange: onChangeFromOrigin, onPressEnter,
    key, suffixTestId, allowClear, onBlur, compareWithAdditionlData = [], maxLength, className,
  } = formConfig;

  const onChange = (event: any, labelConfig: any): void => {
    if (onChangeFromOrigin) {
      onChangeFromOrigin(event, labelConfig);
    }
  };

  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === ' ') {
      event.preventDefault();
    }
  };

  return <FormItem
    formConfig={formConfig}
    extraRules={[multiEmailValidation(key, compareWithAdditionlData, maxLength)]}
  >
    <Input
      allowClear={allowClear}
      data-testid={`${key}${suffixTestId || ''}`}
      placeholder={placeholder}
      disabled={disabled}
      autoComplete="off"
      onChange={(event: InputProps): void => onChange(event, label)}
      onKeyDown={onKeyDown}
      onPressEnter={onPressEnter}
      onBlur={onBlur}
      className= {className} />
  </FormItem>;
};

export default FormMultiEmailInput;
